import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import Home from "@modules/home/components/home";
import {defaultRoute, getProps} from "@modules/home/helpers/config";

export default new ClientModule({
	route:{ TypeIsFront    : <Route {...getProps(defaultRoute, Home, {})} runtimejs /> }
});
